import { ConfirmationType } from "./types";

export default function getConfirmationTypeName(type: ConfirmationType | `${ConfirmationType}` | ''): string {

    if(!type) return ''

    const names: Record<ConfirmationType, string> = {
        [ConfirmationType.Cancel]: 'Есть вероятность отмены',
        [ConfirmationType.Long]: 'Выгодно, если подождать',
        [ConfirmationType.Quick]: 'Быстрое подтверждение',
    };

    return names[type] || '';
}